import React from 'react';
import type { PlayerAddressProps } from '../../types';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type AddressCardProps = {
    address:PlayerAddressProps,
    hide_delete?:boolean,
    onDelete:(address:PlayerAddressProps) => void,
    onSelect:(address:PlayerAddressProps) => void
}

const AddressCard = ({ hide_delete, address, onSelect, onDelete }:AddressCardProps) => {
    const Colors = useColors();
    return (
        <View nativeID='address_info' style={{ padding:10, flexDirection:'row', alignItems:'center', borderWidth:1, borderColor:Colors.borders.light, borderRadius:8 }} >
            <Button style={{ flex:1, padding:5 }} onPress={() => onSelect(address)}>
                <Text theme='h1' size={16}>{address.name}</Text>
                <Text style={{ marginTop:4 }} size={14} theme='description'>{address.street}</Text>
                <Text style={{ marginTop:2 }} size={14} theme='description'>{address.city} {address.state} {address.zip}</Text>
            </Button>
            {!hide_delete ?
            <Button
                title='DELETE'
                style={{ padding:10 }}
                type='error'
                onPress={() => onDelete(address)}
            />
            :<></>}
        </View>
    )
}

export default AddressCard